import ColorPicker from '@/src/components/ColorPicker/ColorPicker';
import React from 'react';

const C = (props) => {
  const { value, onChange, disabled, defaultValue } = props;

  return (
    <ColorPicker
      multi
      onChange={onChange}
      color={value}
      disable={disabled}
      defaultValue={defaultValue}
    />
  );
};
export default C;
